import { render } from "./Blanquear.vue?vue&type=template&id=6122fa4c&scoped=true"
import script from "./Blanquear.vue?vue&type=script&lang=js"
export * from "./Blanquear.vue?vue&type=script&lang=js"

import "./Blanquear.vue?vue&type=style&index=0&id=6122fa4c&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6122fa4c"]])

export default __exports__